<template>
  <b-modal ref="new-workstation" hide-footer :title="getText().title">
    <div class="d-block text-center">
      <b-container fluid>
        <b-form @submit="onSubmit">
                    <b-form-group
                        id="loopName"
                        label="Nom"
                        label-for="loopInputName">
                        <b-form-input
                        id="loopInputName"
                        type="text"
                        v-model="workstation.name"
                        required
                        placeholder="Entrez le nom"
                        />
                    </b-form-group>
                    <b-form-group
                        id="loopDescription"
                        label="Position"
                        label-for="loopDescription1">
                        <b-form-input
                        id="loopDescription1"
                        type="number"
                        v-model="workstation.position"
                        required
                        placeholder="Entrez la description"
                        />
                    </b-form-group>
                    <b-button type="submit" variant="primary">{{ getText().btnText }}</b-button>
                </b-form>
        <b-row>
          <b-col sm="5">
            <b-button
              class="mt-3"
              variant="outline-danger"
              block
              @click="hideModal()"
            >
              Annuler
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import server from '../../api/server.vue'

export default {
  name: 'NewWorkstation',
  props: ['loop', 'workstation', 'workstation_name'],
  data() {
    return {
      title: "Nouvelle Workstation",
      btnText: "Créer"
    }
  },
  computed: {
  },
  methods: {
    hideModal (needReload=false) {
      if(needReload) {
         window.location.reload()
      }
      this.$refs['new-workstation'].hide()
    },
    showModal () {
      this.$refs['new-workstation'].show()
          // this.hideModal()()
    },
     onSubmit(evt) {
        evt.preventDefault()
        if (this.workstation_name === undefined) {
            this.workstation_to_update = "NO_WORKSTATION"
        } else {
            this.workstation_to_update = this.workstation_name
        }
        server.updateWorkstation(this.loop, {'workstation_to_update': this.workstation_to_update ,'name': this.workstation.name, 'position': this.workstation.position}).then(() => {
            this.makeToast("MaJ réussie !")
            this.hideModal(true)
        })
      },
      onReset(evt) {
        evt.preventDefault()
        /* Reset our form values */
        this.resetValues()
        /* Trick to reset/clear native browser form validation state */
        this.show = false
        this.$nextTick(() => {
            this.show = true
        })
      },
      getText() {
        if (this.workstation_name !== undefined && this.workstation_name !== "") {
          this.title = "Mise à jour de " + this.workstation_name
          this.btnText = "Mettre à jour"
        } else {
          this.title = "Nouvelle Workstation"
          this.btnText = "Créer"
        }
        return {'title': this.title, 'btnText': this.btnText}
      }
  },
  mounted: function() {
  },
  components: { }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/loops/NewWorkstationModal.vue